import { SectionHeading } from "./SectionHeading";
import { SpaServiceCard } from "./SpaServiceCard";
import { Flower2, WandSparkles, Gem, Leaf } from "lucide-react";

export const SpaServicesSection = ({ services }) => {
  return (
    <section className="py-10 container-x" data-testid="spa-services-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-end mb-16">
        <div className="lg:col-span-10">
          <SectionHeading
            eyebrow=""
            title="Aesthetics "
            italicWord=""
            kicker={
              <>
                <span className="block whitespace-nowrap font-serif text-2xl italic text-gold md:text-3xl">
                  The face beyond the smile
                </span>
                <span className="mt-2 block">
                  Minimally invasive aesthetic treatments - Botox and Juvederm fillers - performed with a dentist's precision understanding of facial anatomy.
                </span>
              </>
            }
          />
        </div>

      </div>


<div className="border-y border-gold/20 bg-[#f7f2e9] px-6 py-14 md:px-10 md:py-16">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-serif text-2xl font-medium uppercase tracking-[0.08em] text-gold-dark md:text-3xl">
            A Natural Extension of Your Smile
          </h2>
          <div className="mx-auto mt-6 max-w-3xl space-y-4 text-sm leading-relaxed text-ink/75 md:text-base">
            <p>
              A beautiful smile is only one part of facial aesthetics. Our approach considers the relationship between your smile, lips, facial contours, and expression to create results that look balanced, refreshed, and distinctly you.
            </p>
            <p>
              In the privacy and comfort of our spa-inspired practice, we offer personalized Botox® and Juvéderm treatments designed to soften selected lines, restore or enhance facial volume, and complement the smile you already know and love.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-10 grid max-w-6xl grid-cols-2 gap-y-8 border-t border-gold/20 pt-8 md:grid-cols-4 md:gap-0">
          {[
            { label: <>Personalized<br />Treatments</>, Icon: Flower2 },
            { label: <>Natural-Looking<br />Results</>, Icon: WandSparkles },
            { label: <>Dental Expertise<br />in Facial Anatomy</>, Icon: Gem },
            { label: <>Private,<br />Spa-Like Environment</>, Icon: Leaf },
          ].map(({ label, Icon }, index) => (
            <div
              key={index}
              className="flex flex-col items-center gap-3 px-3 text-center md:border-r md:border-gold/20 md:last:border-r-0 md:px-5"
            >
              <Icon size={28} strokeWidth={1.4} className="text-gold" aria-hidden="true" />
              <p className="text-[10px] font-medium uppercase leading-relaxed tracking-[0.14em] text-ink/75 sm:text-xs">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-px bg-ink/10 lg:auto-rows-[460px]">
        {services.map((service, index) => (
          <SpaServiceCard key={service.slug} service={service} index={index} />
        ))}
      </div>

      <div className="border-t border-[#B79A68]"/>

       <div
          data-testid="spa-service-video"
          className="mt-px grid grid-cols-1 bg-cream reveal lg:grid-cols-12 py-3"
          style={{ transitionDelay: `${services.length * 60}ms` }}
        >
          <div className="h-[80vh] min-h-[420px] overflow-hidden lg:col-span-4">
            <video
              className="w-full h-full object-cover scale-125"
              src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/testimonials/8bdce0df-5e4c-4aa6-b458-fe1351b40c6d.mp4"
              autoPlay
              loop
              muted
              controls
              playsInline
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="flex flex-col justify-center p-8 md:p-10 lg:p-14 lg:col-span-6">
            <p className="label-eyebrow mb-5 text-lg">A Dentist's Approach to Facial Aesthetics</p>
            <div className="max-w-2xl space-y-5 text-ink/70">
              <p className="text-md leading-relaxed">

                Dentistry is about more than teeth. The smile exists within the architecture of the entire face.
              </p>
              <p className="text-md leading-relaxed">
                Dr. K.'s approach to facial aesthetics, with the same attention to proportion, symmetry, anatomy, and detail that guides every smile she creates. Botox and dermal filler treatments are individually planned to complement your facial features rather than simply treat an isolated line or area.
              </p>
              <p className="text-md leading-relaxed">

                The objective is not to make you look different. It is to help you look refreshed, balanced, and naturally yourself.
              </p>
              <div className="pt-2">
                <p className="font-serif text-xl text-ink">Dr. K.</p>
                <p className="mt-1 font-serif italic text-gold-dark">Expertise. Artistry. A More Confident You.</p>
              </div>
            </div>
          </div>
          <div className="flex items-center p-8 md:p-10 lg:p-14 lg:col-span-2">
            <blockquote className="border-l border-gold pl-5 font-serif text-xl italic font-bold leading-snug text-gold-dark">
              “Your best features deserve a holistic approach.”
            </blockquote>
          </div>
        </div>
    </section>
  );
};
